import { cn } from "@/lib/utils";

interface CharacterCounterProps {
  current: number;
  max: number;
  className?: string;
}

const toPersianNumber = (num: number): string => {
  const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
  return num
    .toLocaleString("en-US")
    .replace(/\d/g, (d) => persianDigits[Number(d)]);
};

export const CharacterCounter: React.FC<CharacterCounterProps> = ({
  current,
  max,
  className,
}) => {
  const isWarning = current > max * 0.9;
  const isError = current >= max;

  return (
    <p
      dir="ltr"
      className={cn(
        "text-xs text-right", // rtl-ok: dir=ltr makes text-right correct here
        isError
          ? "text-semantic-error"
          : isWarning
            ? "text-semantic-alert"
            : "text-text-secondary",
        className,
      )}
    >
      {toPersianNumber(current)} / {toPersianNumber(max)}
    </p>
  );
};
